import { Block } from 'webiq.boilerplate'

export default class CheckoutParcelshopSelect extends Block {
	static title = 'checkout-parcelshops-select'

	init() {
        this.select = this.element.querySelector("sl-select")
        this.loader = this.element.querySelector("sl-spinner")

        this.select.addEventListener('sl-change', () => {
            document.querySelector('.checkout-parcelshop__info-overlay').classList.remove('tw-hidden')
            this.loader.classList.remove('tw-hidden')
            this.getParcelshopInfo(this.select.value)
        })

        window.eventEmitter.on("parcelshop:show", () => {
            this.select.disabled = false
        })

        window.eventEmitter.on("parcelshop:hide", () => {
            this.select.disabled = true
        })

        window.eventEmitter.on("parcelshop:reload", (data) => {
            if (data.disabled === false) {
                this.select.disabled = false
            }
        })

        window.eventEmitter.on("parcelshop:done", () => {
            this.loader.classList.add('tw-hidden')
        })

        window.eventEmitter.on("parcelshop:loading", () => {
            this.select.disabled = true
            this.loader.classList.remove('tw-hidden')
        })
	}

    getParcelshopInfo($parcelshopId) {
        const payload = new FormData()
		payload.append('parcelshop_id', $parcelshopId)
		payload.append('parcelshop_info', true)

		fetch('/parcelshop', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
                if (json.parcelshop) {
                    window.eventEmitter.emit('parcelshop:info', json.parcelshop)
                }
			})
			.catch((error) => {
                console.log(error)
            })
    }
}
